import ViewDownload from 'elements/ViewDownload'
import Auth from 'modules/Authentication'
import { streamUrl } from 'variables'
import SalesContractsApi from '../../../../api/Sales/SalesContracts'
import CustomSpin from '../../../../elements/CustomSpin'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import withFormItemView from 'form-item-view-hoc'
import React, { Fragment } from 'react'
import { Button, Col, Form, Icon, Input, Row, Upload } from 'antd'
import { compose } from 'recompose'
import { isEmpty } from 'lodash'
import withData from '../../../../elements/Select/withData'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import withSort from '../../../../elements/HOC/withSort'

const ContractTemplateSelect = withData({
  data: [
    { key: 'CLP', value: 'CLP' },
    { key: 'EM_IQ', value: 'EM_IQ' },
  ],
  withSort,
})(CustomSelect)
const CustomFormItem = compose(withFormItemView)(Form.Item)

const salesContractsApi = new SalesContractsApi()

function SelectUploadForm(props) {
  const { onFileLoaded, csvFileList, transactionUploadList, beforeUpload, enquiry, details } = props
  const { getFieldDecorator, getFieldValue } = props.form

  const auth = new Auth()

  const propsUpload = {
    onChange: onFileLoaded,
    beforeUpload: beforeUpload,
    fileList: csvFileList,
  }

  ///salesContracts/:key
  const { fetch, fetching, object } = useFetchObject(
    () => salesContractsApi.get(enquiry.contract._id.replace('salesContracts/', '')),
    false,
    [enquiry.contract._id],
    isEmpty(enquiry.contract._id)
  )

  console.log({ object })
  return (
    <Fragment>
      <CustomSpin spinning={fetching}>
        <Form>
          <Row>
            <Col span={12}>
              <CustomFormItem readOnly={true} {...defaultFormItemLayout} label={'Enquiry'}>
                <Input value={enquiry.title} />
              </CustomFormItem>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Contract Template'}>
                {getFieldDecorator('template', {
                  initialValue: object.template,
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Bank Template !',
                    },
                  ],
                })(<ContractTemplateSelect style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          {getFieldValue('template') === 'CLP' && (
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'Download Template'}>
                  <ViewDownload
                    view={`${streamUrl}files/10334097383046?action=view&access_token=${auth.getAccessToken()}`}
                    download={`${streamUrl}files/10334097383046?action=download&access_token=${auth.getAccessToken()}`}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'File'}>
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: 'Please Select a File!' }],
                })(
                  <Upload {...propsUpload}>
                    <Button>
                      <Icon type="upload" /> Select File
                    </Button>
                  </Upload>
                )}
                {transactionUploadList.length > 0 && (
                  <span>{`Records to be uploaded ${transactionUploadList.length}`}</span>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomSpin>
    </Fragment>
  )
}

SelectUploadForm.propTypes = {}
SelectUploadForm.defaultProps = {}

export default compose(Form.create())(SelectUploadForm)
